import { Switch } from 'antd';
import { Country, useUpdateCountry } from 'entities/country';

const CountryStatusSwitcher = ({ record }: { record: Country }): React.ReactElement => {
  const { mutateAsync: updateCountry } = useUpdateCountry(record.id);

  return (
    <Switch
      size="small"
      checked={record.active}
      onChange={(checked) => updateCountry({ id: record.id, status: checked })}
    />
  );
};

export { CountryStatusSwitcher };
